/**
 * InfoField
 */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useIntl } from 'react-intl';
import EditButton from 'components/interaction/EditButton.js';
import FormModal from 'components/interaction/FormModal/index.jsx';
import messages from '../messages.js';
import Value from './Value.jsx';

const Wrapper = styled.div`
  header + span {
    display: inline-block;
    min-height: 34px;
  }
  min-width: ${(p) => p.width};
`;

function InfoField(props) {
  const { minWidth, label, value = '', skip, editFields = [], editSchema, user, onChange } = props;
  const [show, setShow] = useState(false);
  const intl = useIntl();
  if (skip) {
    return null;
  }

  function handleSubmit(values) {
    onChange({ ...user, ...values });
    setShow(false);
  }

  const canEdit = Boolean(editSchema) || editFields.length > 0;
  const translatedLabel = label ? intl.formatMessage(label) : null;
  return (
    <Wrapper width={minWidth}>
      <header>
        <span className="fw-semibold text-muted">{translatedLabel}</span>
        {canEdit && <EditButton className="ms-2" onClick={() => setShow(true)} /> }
      </header>
      <Value value={value} />
      {editSchema && (
        <FormModal
          show={show}
          title={{ ...messages.updateField, values: { field: translatedLabel } }}
          schema={editSchema}
          onHide={() => setShow(false)}
          onSubmit={handleSubmit}
          values={user}
          size="sm"
        />
      )}
    </Wrapper>
  );
}

InfoField.propTypes = {
  label: PropTypes.object,
  value: PropTypes.any,
  skip: PropTypes.bool,
  minWidth: PropTypes.string,
  editFields: PropTypes.array,
  editSchema: PropTypes.object,
  user: PropTypes.object,
  onChange: PropTypes.func,
};

export default InfoField;
